function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPluscircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1021.75 12 9.761 9.761 0 0012 2.25zm3.75 10.5h-3v3a.75.75 0 11-1.5 0v-3h-3a.75.75 0 110-1.5h3v-3a.75.75 0 111.5 0v3h3a.75.75 0 110 1.5z",
    fill: props.fill
  }));
}

export default SvgPluscircle;